import { SCHEDULING_CONFLICTS_ABORT } from '../constants';
import config from '../config';

class AddSickCalloutCtrl {
  ADD_SICK_CALLOUT_BY_RANGE_ENABLED = config.ADD_SICK_CALLOUT_BY_RANGE_ENABLED;

  constructor(
    Restangular,
    Authentication,
    AlertService,
    ConfirmService,
    EventCollection,
    ShiftUtils,
    Utils,
    LeaveService,
    sdk,
    $state
  ) {
    'ngInject';

    Object.assign(this, {
      Restangular,
      Authentication,
      AlertService,
      ConfirmService,
      EventCollection,
      ShiftUtils,
      Utils,
      LeaveService,
      sdk,
      $state,
    });
    this.sickCallout = {};
    this.isManager = Authentication.user.isManager;
    this.shiftTo = [];
  }

  $onInit() {
    this.userId = this.data.user.id;
    this.sickCallout = this._getFormData();
    this.paidLeave = false;
    this.setSickCalloutSummary();
    this.mode = 'single';
    this.rangeStart = this.data.dtstart;

    const instance = this;
    this._endDatepickerOptions = {
      get minDate() {
        return instance.rangeStart;
      },
    };
  }

  get leaveSickEnabled() {
    return this.LeaveService.isLeaveSickEnabled();
  }

  get unpaidLeave() {
    return !this.sickCallout.paid;
  }

  set unpaidLeave(val) {
    this.sickCallout.paid = !val;
  }

  navigateToUserProfile() {
    const { user } = this.data;
    if (!user.deleted) {
      this.$state.go('users.profile', { userId: user.id });
    }
  }

  async setSickCalloutSummary() {
    this.sickCalloutSummary = await this.LeaveService.getSickCalloutSummary(this.userId);
  }

  _handleError(error) {
    if (error && error !== SCHEDULING_CONFLICTS_ABORT) {
      this.error = this.Utils.getErrorMessages(error);
    }
  }

  async submit(_sickCallout) {
    if (this.form.$invalid) {
      this.form.$setSubmitted();
      return;
    }

    const sickCallout = { ..._sickCallout };

    if (
      sickCallout.shiftAction &&
      ['assign', 'offer'].includes(sickCallout.shiftAction) &&
      this.shiftTo.length
    ) {
      sickCallout.shiftRecipientId = this.shiftTo[0]?.id;
    }

    if (!this.leaveSickEnabled) {
      delete sickCallout.paid;
    }

    if (this.mode === 'multi') {
      delete sickCallout.shiftId;
      sickCallout.rangeStart = this.Utils.formatDate(this.rangeStart);
      sickCallout.rangeEnd = this.Utils.formatDate(this.rangeEnd);
      sickCallout.userId = this.data.user.id;
    }

    try {
      const checkRestBreakConflicts = config.CLOPENING_CONFLICT_ENABLED;

      const shifts = await this.ShiftUtils.performConflictingRequest({
        request: (ignoreConflicts) =>
          this.EventCollection.addSickCallout(
            sickCallout,
            { ignoreConflicts, checkRestBreakConflicts },
            { ignoreGlobalErrorHandler: true }
          ),
        ignoreSuffix: 'assign this shift anyway',
      });

      this.EventCollection.undoingPossible = true;
      this.AlertService.success('Shift marked as sick callout');
      this.modal.close(shifts);
    } catch (e) {
      this._handleError(e);
      throw e; // for progress-button
    }
  }

  _getFormData() {
    return {
      comment: '',
      shiftId: this.data.id,
      paid: true,
    };
  }

  get endDatepickerOptions() {
    return this._endDatepickerOptions;
  }
}

export default AddSickCalloutCtrl;
